import { Link, useForm, usePage } from '@inertiajs/react'
import { Button } from '@/shared/ui/button'
import { Input } from '@/shared/ui/input'
import { Label } from '@/shared/ui/label'
import { t } from '@/shared/lib/i18n'
import { newSessionPath, passwordResetPath } from '@/shared/lib/routes'
import { AuthShell } from './AuthShell'

interface ForgotPasswordPageProps {
  flash?: { alert?: string; notice?: string }
  [key: string]: unknown
}

const ForgotPassword = () => {
  const { flash } = usePage<ForgotPasswordPageProps>().props

  const form = useForm({ email: '' })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    form.post(passwordResetPath())
  }

  return (
    <AuthShell pageTitle={t('auth.forgotPassword.title')}>
      <h1 className="text-2xl font-bold">{t('auth.forgotPassword.title')}</h1>

      <p className="text-sm text-muted-foreground">{t('auth.forgotPassword.hint')}</p>

      {flash?.notice && (
        <div className="rounded-md border border-emerald-500/50 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">
          {flash.notice}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email">{t('auth.forgotPassword.emailLabel')}</Label>
          <Input
            id="email"
            type="email"
            autoComplete="email"
            value={form.data.email}
            onChange={(e) => form.setData('email', e.target.value)}
            required
          />
        </div>
        <Button type="submit" className="w-full" disabled={form.processing}>
          {form.processing ? t('auth.forgotPassword.submitting') : t('auth.forgotPassword.submit')}
        </Button>
        <div className="text-center">
          <Link
            href={newSessionPath()}
            className="text-sm text-muted-foreground underline-offset-4 hover:underline"
          >
            {t('auth.forgotPassword.backToLogin')}
          </Link>
        </div>
      </form>
    </AuthShell>
  )
}

export default ForgotPassword
